import PropTypes from "prop-types";
import Button from "./Button";
import React from "react";

const PolicyAliasModal = ({ title, body, onClick }) => {
  return (
    <div
      style={{ top: 0, left: 0, bottom: 0, right: 0 }}
      className="flex flex-col items-center justify-center min-h-screen max-w-screen fixed lg:pl-[240px]"
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="flex items-center justify-center">
          <img
            src={require("../assets/warningGeneral.png")}
            alt="success"
            width="80px"
            height="80px"
          />
        </div>

        <div className="text-center font-semibold mt-1">{title}</div>

        <div className="text-center my-2">{body}</div>

        <div className="mt-5">
          <Button className="w-full text-white" onClick={onClick}>
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};

PolicyAliasModal.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  onClick: PropTypes.func,
};

export default PolicyAliasModal;
